import React from "react";

import { Typography, Button } from "@material-ui/core";

import { Modal, ModalHeader, ModalFooter, ModalBody } from "reactstrap";

export class RemoveFileModal extends React.Component {
    render() {
        const {
            closeModal,
            files,
            removeFile,
            removeFail,
            removeSuccess,
            removeFileModal,
        } = this.props;

        return (
            <Modal isOpen={removeFileModal}>
                <ModalHeader>Remove File</ModalHeader>
                <ModalBody>
                    <ModalInfoText text=" Are you sure you want to remove these files?" />

                    {files &&
                        files.map((e) => {
                            if (e.selected)
                                return (
                                    <Typography key={e.file_id}>
                                        {e.file_name}
                                    </Typography>
                                );
                            else return null;
                        })}
                </ModalBody>
                <ModalFooter>
                    <Button
                        onClick={() => {
                            closeModal(false, false);
                        }}
                        variant="contained"
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={() => {
                            removeFile(files, success => {
                                //console.log(success);

                                if (success) removeSuccess(false, true, false);
                                else removeFail(false, true, false);
                            });
                        }}
                        color="primary"
                        variant="contained"
                    >
                        Remove
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
}
const ModalInfoText = (props) => {
    return (
        <Typography variant="subheading" style={{ marginBottom: 15 }}>
            {props.text}
        </Typography>
    );
};
